import React from "react";
import {
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  TableContainer,
  Table,
  Paper,
  TextField,
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const formatCurrency = (value) => {
  return Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

function RowsTable({ rows, total }) {
  return (
    <TableContainer component={Paper} style={{ width: "100%" }}>
      <Table size="small">
        <TableHead style={{ textTransform: "uppercase" }}>
          <TableRow>
            <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
              Description
            </TableCell>
            <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
              Price
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                <TextField
                  required
                  label=""
                  variant="standard"
                  disabled
                  value={row.description}
                  style={{ width: "100%" }}
                  InputProps={{ disableUnderline: true }}
                />
              </TableCell>
              <TableCell>
                <TextField
                  required
                  label=""
                  variant="standard"
                  type="text"
                  disabled
                  value={formatCurrency(row.price)}
                  style={{ width: "100%" }}
                  InputProps={{
                    disableUnderline: true,
                    startAdornment: (
                      <AttachMoneyIcon
                        style={{ fontSize: 16 }}
                      ></AttachMoneyIcon>
                    ),
                  }}
                />
              </TableCell>
            </TableRow>
          ))}
          {/*Total Row*/}
          <TableRow>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              TOTAL
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              ${formatCurrency(total)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default RowsTable;
